<template>
	<form class="user-change-phone-form" @submit.prevent="submitForm">
		<errors-list :errors="errors"/>
		<default-field-box type="tel" name="phone" :placeholder="$t('forms.phone')" :required="true" 
			v-model="phone" event="phone-field-changed"/>
		<div class="form-actions">
			<button class="button style-4" :class="loading ? 'loading' : ''">
				<span class="inner">{{ $t('forms.change') }}</span>
			</button>
			<a href="#" class="link" @click.prevent="handleBackButton">{{ $t('general.back')}}</a>
		</div>
	</form>
</template>

<script>
	import DefaultFieldBox from "../form-fields/DefaultFieldBox";
	import ErrorsList from "../containers/ErrorsList";
	import { trackEvent } from '@/analytics';

	export default {
		name: "UserChangePhoneForm",
		components: {
			DefaultFieldBox,
			ErrorsList
		},
		data() {
			return {
				loading: false,
				errors: [],
				phone: '',
			}
		},
		methods: {
			submitForm(){
				if(!this.phone || this.loading){
					return;
				}

				this.loading = true;
				trackEvent('form_submit', { form_name: 'change_phone', module: 'auth' });
				this.axios.post('/api/user', {
					_method: 'PUT',
					phone: this.phone,
				}).then((response) => {
					this._submitSuccess = true;
					trackEvent('form_submit_success', { form_name: 'change_phone', module: 'auth' });
					this.loading = false;
					this.$emit('phone-changed', this.phone);
				}).catch(error => {
					trackEvent('form_submit_error', {
						form_name: 'change_phone',
						module: 'auth',
						error_message: error.response && error.response.data ? error.response.data.message : error.message,
						error_status: error.response ? String(error.response.status) : null,
					});
					this.$swal.fire({
						icon: 'error',
						title: 'Oops',
						text: error.response.data.message
					});

					if (error.response.data.errors) {
						this.errors = error.response.data.errors;
					}
					this.loading = false;
				});
			},
			handleBackButton(){
				this.$emit('show-activation-form');
			},
			processPhoneFieldChanged(data){
				this.phone = data.value;
			}
		},
		mounted() {
			this._submitSuccess = false;
			trackEvent('form_open', { form_name: 'change_phone', module: 'auth' });
			this.$root.$on('phone-field-changed', (data) => {
				this.processPhoneFieldChanged(data);
			});
		},
		beforeDestroy() {
			if (!this._submitSuccess) {
				trackEvent('form_close', { form_name: 'change_phone', module: 'auth' });
			}
		},
		destroyed() {
			this.$root.$off('phone-field-changed');
		}
	}
</script>

<style scoped lang="scss">
	.link {
		color: var(--font-color);
		&:hover {
			color: var(--white-color);
		}
	}
	.button {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}
</style>